import { render, staticRenderFns } from "./FilterItemActive.vue?vue&type=template&id=b156d63c&scoped=true&"
import script from "./FilterItemActive.vue?vue&type=script&lang=js&"
export * from "./FilterItemActive.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemActive.vue?vue&type=style&index=0&id=b156d63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156d63c",
  null
  
)

export default component.exports